import { CsvColumn } from "./CsvHelpers.types";
import Papa from "papaparse";

class CsvHelpers {
  /**
   * Simple safari detection based on user agent test
   */
  static isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  /**
   * Inspired by {@link|https://github.com/react-csv/react-csv/blob/master/src/core.js}
   */
  static buildURI<T extends {}>(
    headers: CsvColumn<T>[],
    data: Partial<T>[],
    options?: { uFEFF: boolean; separator: string }
  ) {
    const { uFEFF = false, separator = "," } = options || {};

    const csvContent = [
      headers.map((header) => header.label).join(separator),
      ...data.map((row) => headers.map((header) => `${row[header.key]}`).join(separator)),
    ];

    const csv = csvContent.join(`\n`);

    const type = CsvHelpers.isSafari() ? "application/csv" : "text/csv";
    const blob = new Blob([uFEFF ? "\uFEFF" : "", csv], { type });
    const dataURI = `data:${type};charset=utf-8,${uFEFF ? "\uFEFF" : ""}${csv}`;

    const URL = window.URL || window.webkitURL;

    return typeof URL.createObjectURL === "undefined" ? dataURI : URL.createObjectURL(blob);
  }

  static readFileAsText(file: File): Promise<string[][]> {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        complete: (results) => {
          if (results.errors.length > 0) {
            reject(new Error(`CSV parsing error: ${results.errors[0].message}`));
          } else {
            resolve(results.data as string[][]);
          }
        },
        error: (error) => {
          reject(error);
        },
        skipEmptyLines: false, // Let AthleteHelpers handle empty row filtering
        header: false, // Return raw array data
      });
    });
  }
}

export default CsvHelpers;
